import { client } from './client';

// eslint-disable-next-line
export const list = params => client.get('tickets', { params: params });

// eslint-disable-next-line
export const newTicket = params => {

  const formData = new FormData();
  params.files.forEach(element => {
    formData.append('params[files][]', element);
  });
  
  // formData.append('params[files]', params.files);
  formData.append('params[subject]', params.subject);
  formData.append('params[description]', params.description);
  formData.append('params[sale_code]', params.sale_code);  

  return client.post('tickets', formData);
}


// const headers = { 'Content-Type': 'multipart/form-data' };
// axios.post('https://httpbin.org/post', formData, { headers }).then((res) => {
//   res.data.files; // binary representation of the file
//   res.status; // HTTP status
// });


// eslint-disable-next-line
export const get = id => client.get(`tickets/${id}`);

// eslint-disable-next-line
export const newComment = params => {
  const formData = new FormData();
  
  // Se há files anexados, adicionar ao formData
  if (params.files && params.files.length > 0) {
    params.files.forEach(element => {
      formData.append('params[files][]', element);
    });
  }
  
  formData.append('params[comment]', params.message);
  formData.append('params[ticketId]', params.ticketId);
  formData.append('params[isFile]', params.isFile || false);
  
  return client.post('tickets/comments', formData);
}


// eslint-disable-next-line
export const notifications = () => client.get('tickets-notifications');

// eslint-disable-next-line
export const upload = params => client.post('tickets/upload', { params: params });
